import { render, staticRenderFns } from "./CommonCollapse1.vue?vue&type=template&id=ede16e46&scoped=true&"
import script from "./CommonCollapse1.vue?vue&type=script&lang=js&"
export * from "./CommonCollapse1.vue?vue&type=script&lang=js&"
import style0 from "./CommonCollapse1.vue?vue&type=style&index=0&id=ede16e46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede16e46",
  null
  
)

export default component.exports